module.exports = __webpack_public_path__ + "img/PPT.3f69b9d8.svg";